import ErrorExample from "./examples/Error.Example";
import InfoExample from "./examples/Info.Example";
import WarningExample from "./examples/Warning.Example";

export default [
    {
        title: "Info message card",
        component: InfoExample,
        code: require("!raw-loader!./examples/Info.Example.tsx")
    },
    {
        title: "Warning message card",
        component: WarningExample,
        code: require("!raw-loader!./examples/Warning.Example.tsx")
    },
    {
        title: "Error message card",
        component: ErrorExample,
        code: require("!raw-loader!./examples/Error.Example.tsx")
    }
];
